import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Autocomplete,
  TextField,
  Button,
  Checkbox,
  Switch,
} from "@mui/material";
import React, {useState, useEffect} from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from "react-router-dom";
import Snack from "components/Snack";
import Skeleton from "./skeleton"; 
import _ from "lodash";
import {getLocations} from '../utils';
import { updateoneilAccess } from "redux/actions/addEditWorker";

const ONEIL = ({handleChange}) => {
    const location = useLocation();
    const dispatch = useDispatch();
    const workerData = location.state && location.state.worker ? location.state.worker : null;
    const empId = location.state && location.state.empId ? location.state.empId : '';
    const approveForMgr = location.state && location.state.approveForManager
                              ? location.state.approveForManager : {};
    const user = useSelector((state) => state.user.auth.user);  
    const oneilData = useSelector(state => state.addEditWorker.workerRoles.ONEIL || {});
    const loadingRoles = useSelector(state => state.addEditWorker.loadingRoles);
    const imtRole = useSelector((state) => state.user.imtRole || null);
    const [formValues, setFormValues] = useState({});
    const [formErrors, setFormErrors] = useState({});
    const [snackControl, setSnackControl] = useState({ open: false, message: "", severity: 'success' });
    const [disableSave, setDisableSave] = useState(true);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [buildingOptions, setBuildingOptions] = useState([]);
    const [roleOptions, setRoleOptions] = useState(["Worker", "Project Manager", "Supervisor","Administrator"])
    const [readOnly, setReadOnly] = useState(true);

    useEffect(() => {
      console.log("IMTime Role", imtRole)
      if(imtRole?.userRole?.role !== "Support"){
          setReadOnly(false);
      }
    },[imtRole])

  useEffect(() => {
      if(!districtOptions.length >0){
        getLocations().then(data => {
          const { oneilEnableList=[] } = data;
          setDistrictOptions([...oneilEnableList]);
        });
      }
  }, [])

  useEffect(() => {
    if(oneilData && Object.keys(oneilData).length>0){
      setFormValues(_.cloneDeep(oneilData));
    }
  }, [oneilData])

  useEffect(() => {
    console.log("ONEIL formValues", formValues);
    if(formValues?.onlDistricts?.length>0 && districtOptions.length>0){
      console.log("ONEIL buildings", districtOptions.length);
      const buildingOptions = [];
      districtOptions.forEach(record => {
        if(formValues?.onlDistricts?.includes(record?.district)){
          const allBuildings = record?.buildings || {};
          console.log("ONEIL buildings", formValues?.onlDistricts, allBuildings);
          Object.keys(allBuildings).forEach(building => {
            if(allBuildings[building].wms === 'LTP'){
              const option = {
                buildingID: building,
                districtID: record?.district || ""
              }
              buildingOptions.push(option);
            } 
          })
        }
      })
      setBuildingOptions(buildingOptions);
    }else{
      setBuildingOptions([]);
    }
    validForm(formValues);
  } ,[formValues, districtOptions])

  const validForm = (formValues) => {
    let errors = {};
    if(formValues?.isActive){
      if(!formValues?.role){
        errors['role'] = "Field is required";
      }
      if(!formValues?.userId){
        errors['userId'] = "Field is required";
      }
      if(!formValues?.onlBuildings?.length > 0){
        errors['onlBuildings'] = "Field is required";
      }
      if(!formValues?.onlDistricts?.length > 0){
        errors['onlDistricts'] = "Field is required";
      }
    }
    setFormErrors(errors);
    const isValid = !Object.keys(errors).length > 0 && !_.isEqual(formValues, oneilData);
    setDisableSave(!isValid);
    return isValid;
  }

  const handleCloseSnack =  () => {
    setSnackControl(state => ({...state, open:false, message: ""}));
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    try{
      const isValidForm = validForm(formValues);
      if(!isValidForm){
        throw new Error("Invalid data. Please check!")
      }
      
      const data = {
        actionTS: new Date().toISOString(),
        actionBy: user?.workerId,
        userId: formValues?.userId || "",
        role: formValues?.role || "",
        onlDistricts: formValues?.onlDistricts || [],
        onlBuildings: formValues?.onlBuildings || [],
        isActive: formValues?.isActive ? true : false,
        activityFamilyId: 'ONEIL'
      }
      console.log("ONEIL submit", formValues, data);
      const response = await dispatch(updateoneilAccess(data, workerData));
      if(response && response.status){
        setSnackControl({
          open: true,
          message: "ONEIL Access updated successfully.",
          severity: 'success'
        })
      }else{
        setSnackControl({
          open: true,
          message: "ONEIL Access update failed.",
          severity: 'error'
        })
      }


    }catch(error){
      console.log("ONEIL handleSumit error", error);
      setSnackControl({
        open: true,
        message: "ONEIL Access failed to submit.",
        severity: "error"
      })
    }
  }

  return (
    <>
      <Box>
        <form action="" id="formData">
           <Snack 
              openSnack={snackControl?.open} 
              severity={snackControl?.severity} 
              message={snackControl?.message} 
              handleCloseSnack={handleCloseSnack}>
            </Snack>
          <Card sx={{ overflow: "auto", width: "100%", height:'calc(100vh - 160px)'}}>
          {loadingRoles ? <Skeleton /> : (
            <CardContent
              style={{ marginLeft: "0%", border: "none", paddingTop: 40 }}
            >
              <Typography variant="h5" color="#616161" marginBottom={3}>
                ONEIL
              </Typography>
              <hr id="customHr2" />
              <>
                <Grid container spacing={3} marginTop={2} paddingLeft={3}>
                  <Grid
                    container
                    columnSpacing={3}
                    marginBottom={2}
                    alignItems="center"
                  >
                    <Grid item xs={2}  md={2} lg ={0.7}>
                      <Typography sx={{ fontSize: "18px" }}>Enable</Typography>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Switch 
                         inputProps={{ 'aria-label': 'Enable ONEIL Role switch' }}
                         checked={formValues?.isActive}
                         onChange={(e) => {
                           let checked = e.target.checked;
                           setFormValues({ ...formValues, isActive: checked });
                         }}
                         disabled={readOnly}
                      />
                    </Grid>
                  </Grid>
                  <Grid container columnSpacing={5} spacing={3} marginBottom={2}>
                    <Grid item xs={12} md={6} lg={3}>
                      <TextField 
                        sx={{ maxWidth: 300, width: "100%" }} 
                        label="User ID" 
                        required 
                        size="small"
                        error={formErrors?.userId}
                        helperText={formErrors?.userId}
                        value={formValues?.userId?.trim() || ""}
                        disabled={!formValues?.isActive || readOnly}
                        onChange={e => {
                          let value = e.target.value.trim() || "";
                          setFormValues(prevState => ({...prevState, userId: value}))
                        }}
                        inputProps={{readOnly: readOnly}}
                      />
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <Autocomplete
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Role"
                                required
                                error = {formErrors?.role}
                                helperText= {formErrors?.role}
                              />
                            )}
                            id="role"
                            name="role"
                            size="small"
                            options={roleOptions || []}
                            //readOnly 
                            value={formValues?.role || ""}
                            onChange={(e, v) => {
                              setFormValues(prevState => ({...prevState, role: v? v : ''}));
                            }}
                            disabled = {!formValues?.isActive || readOnly}
                            readOnly={readOnly}
                        />
                    </Grid>
                  </Grid>
                  <Grid container columnSpacing={5} spacing={3} marginBottom={2}>
                    <Grid item xs={12} md={6} lg={3}>
                        <Autocomplete
                            renderInput={(params) => (
                              <TextField 
                                {...params} 
                                label="Select District" 
                                required 
                                error= {formErrors?.onlDistricts}
                                helperText= {formErrors?.onlDistricts}
                              />
                            )}
                            id="onlDistricts"
                            name="onlDistricts"
                            size="small"
                            options={districtOptions || []}
                            multiple
                            disableCloseOnSelect
                            getOptionLabel={(option) => option.district || option}
                            isOptionEqualToValue={(option, value) => option === value || option.district == value}
                            value={formValues?.onlDistricts || []}
                            onChange={(e, v) => {
                              const districtIds = v ? v.map(record => record?.district || record) :[];
                              setFormValues(prevState => ({
                                ...prevState,
                                onlDistricts: districtIds,
                                onlBuildings:  prevState?.onlBuildings ? 
                                prevState?.onlBuildings.filter(record => districtIds.includes(record?.districtID)) : []
                              }))
                            }}
                            disabled = {!formValues?.isActive || readOnly}
                            readOnly={readOnly}
                          />
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                      <Autocomplete
                            renderInput={(params) => (
                              <TextField 
                                {...params} w
                                label="Select Building" 
                                required
                                error= {formErrors?.onlBuildings}
                                helperText= {formErrors?.onlBuildings}
                              />
                            )}
                            id="onlBuildings"
                            name="onlBuildings"
                            size="small"
                            disableCloseOnSelect
                            options={buildingOptions || []}
                            getOptionLabel={option => option.buildingID || option}
                            isOptionEqualToValue={(option, value) => value?.buildingID ? value?.buildingID == option.buildingID : option.buildingID == value }
                            multiple
                            value={formValues?.onlBuildings || []}
                            onChange={(e, v) => {
                              setFormValues(prevState => ({
                                ...prevState,
                                onlBuildings: v ? v : []
                              }))
                            }}
                            disabled = {!formValues?.isActive || readOnly}
                            readOnly={readOnly}
                        />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={8}
                  style={{ marginTop: "2%", textAlign: "right", marginLeft: 4 }}
                >
                  <div>
                    <Button
                      size="medium"
                      variant="outlined"
                      onClick={(e) => handleChange(e, 0)}
                      style={{ marginRight: 10, display: readOnly ? "none" : "" }}
                    >
                      Cancel
                    </Button>
                    <Button
                      style={{ marginRight: 40, display: readOnly ? "none" : "" }}
                      size="medium"
                      variant="contained"
                      id="svBtn"
                      disabled={disableSave}
                      onClick={handleSubmit}
                    >
                      Save
                    </Button>
                  </div>
                </Grid>
              </>
            </CardContent>
          )}
          </Card>
        </form>
      </Box>
    </>
  );
};

export default ONEIL;
